import { useState } from "react";
import { Settings as SettingsIcon, Building2, Shield } from "lucide-react";
import { useAuthContext } from "@/contexts/AuthContext";
import { PlatformOwnerSettings } from "@/components/settings/PlatformOwnerSettings";
import { OrgAdminSettings } from "@/components/settings/OrgAdminSettings";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function Settings() {
  const { isPlatformOwner, orgId } = useAuthContext();
  const [activeView, setActiveView] = useState<string>("organization");

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-6xl mx-auto p-6 space-y-6">
        <div>
          <div className="flex items-center gap-3 mb-2">
            <SettingsIcon className="w-8 h-8" />
            <h1 className="text-3xl font-bold">Settings</h1>
          </div>
          <p className="text-muted-foreground">
            {isPlatformOwner
              ? "Manage platform-wide and organization settings"
              : "Manage your organization and account settings"}
          </p>
        </div>

        {isPlatformOwner ? (
          <Tabs value={activeView} onValueChange={setActiveView} className="space-y-6">
            <TabsList className="grid w-full max-w-md grid-cols-2">
              <TabsTrigger value="organization" className="flex items-center gap-2">
                <Building2 className="w-4 h-4" />
                Organization
              </TabsTrigger>
              <TabsTrigger value="platform" className="flex items-center gap-2">
                <Shield className="w-4 h-4" />
                Platform
              </TabsTrigger>
            </TabsList>

            <TabsContent value="organization">
              <OrgAdminSettings orgId={orgId} />
            </TabsContent>

            <TabsContent value="platform">
              <PlatformOwnerSettings />
            </TabsContent>
          </Tabs>
        ) : (
          <OrgAdminSettings orgId={orgId} />
        )}
      </div>
    </div>
  );
}
